/* eslint-disable no-unused-vars */

import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import classnames from 'classnames';
// import { useEffect, useCallback } from 'react';
// import GraphMap from './components/GraphMap';
import GraphMap from './components/GraphMapRender';
// import GraphMap from './components/demo';

const MemberManagement = (props) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.mm_content}>
      <div className={classnames(styles.table_page, styles.single_component)}>
        <GraphMap />
      </div>
    </div>
  );
};

export default MemberManagement;
